import React from 'react';
import {MeetingTabs} from './components/MeetingTabs';
import {InvitationDataGrid} from './components/InvitationDataGrid';
import {InvitationReviewsInput} from '../../schema-types/globalTypes';
import {
  accountNameColumn,
  clientsColumn,
  dateDeclinedColumn,
  ownerColumn,
  locationColumn,
  propositionTypeColumn,
  // reasonDeclinedColumn,
  rtqStatusColumn,
  ecqStatusColumn,
} from './invitationColumns';
import {InvitationFilters} from './InvitationFilters';
import withAutoFormNew from '../../components/AutoForm/AutoFormNew';
import {InvitationFormSchema, InvitationPageProps} from './invitationFormProps';
import {useInvitationState} from './hooks/useInvitationForm';

const DeclinedInner: React.FC = () => {
  const {values} = useInvitationState('declined');

  // DataGrid columns - using imported column definitions
  const columns = [
    accountNameColumn,
    clientsColumn,
    ownerColumn,
    propositionTypeColumn,
    dateDeclinedColumn,
    locationColumn,
    rtqStatusColumn(false),
    ecqStatusColumn(false),
  ];

  return (
    <>
      <InvitationFilters />
      <InvitationDataGrid
        inviteStatus={InvitationReviewsInput.DECLINED}
        staff={values?.staff}
        search={values?.search}
        columns={columns}
        entityName="declined meetings"
        noDataMessage="No declined meetings found"
      />
    </>
  );
};

const DeclinedWrapped = withAutoFormNew<InvitationFormSchema, InvitationPageProps>(
  DeclinedInner,
  undefined,
  {debugPosition: 'bottom'}
);

export const DeclinedPage: React.FC = () => {
  const initialValue = {
    staff: '',
    search: '',
  };
  return (
    <>
      <MeetingTabs />
      <DeclinedWrapped initialValueOverrides={initialValue} formFields={[]} />
    </>
  );
};
